export const es = {
    'Hello @customer, you received a @amount payment request from @company': 'Hola @customer, recibiste un Link de Pago de @company por @amount',
    'Terms and Conditions': 'Términos y Condiciones',
    'Privacy': 'Aviso de Privacidad',
    'Reason': 'Concepto',
    'Total Amount': 'Monto total:',
    'Contact Details': 'Información de contacto',
    'Email': 'Correo electrónico',
    'Phone Number': 'Numero de telefono',
    'Card Number': 'Número de tarjeta',
    'Card Details': 'Información de la tarjeta',
    'Exp.': 'Exp',
    'Exp. Month': 'Mes exp',
    'Exp. Year': 'Año exp',
    'MM/YY': 'MM/AA',
    'CVV': 'CVV',
    'What is this?': '¿Qué es esto?',
    'Cardholder Name': 'Nombre del tarjetahabiente',
    'Shipping Details': 'Información de envío',
    'Address Line 1': 'Línea 1 de dirección',
    'Address Line 2': 'Línea 2 de dirección',
    'Zip Code': 'Código postal',
    'City': 'Ciudad',
    'State': 'Estado',
    'Continue': 'Siguiente',
    'Pay @amount': 'Pagar @amount',
    'By continuing I am accepting the terms and conditions of the service.': 'Al continuar estoy aceptando los términos y condiciones del servicio.',
    'terms and conditions': 'términos y condiciones',
    '3 digits': '3 dígitos',
    '4 digits': '4 dígitos',

    'Thank you, the payment has been successful': 'Gracias, el pago ha sido exitoso',
    'Please contact @company for any questions regarding your payment.': 'Por favor comúnicate con @company para cualquier duda sobre tu pago',

    'This field is required': 'Este dato es necesario',
    'Must be a number less than @number': 'Debe ser un número menor a @number',
    'Must be a number larger than @number': 'Debe ser un número mayor a @number',
    'Must be at least @number characters': 'Debe ser mínimo de @number caracteres',
    'Must be at most @number characters': 'Debe ser máximo de @number caracteres',

    'Email is required': 'Correo requerido',
    'Invalid email': 'Correo inválido',
    'Phone number is required': 'Número de teléfono requerido',
    'Invalid phone number': 'Número de teléfono inválido',
    'Must be an email': 'Debe ser un correo',
    'Card number is required': 'Número de tarjeta es requerido',
    'Invalid card number': 'Número de tarjeta inválido ',
    'CVV is required': 'CVV requerido',
    'CVV must be at least @number characters': 'CVV debe ser al menos de @number dígitos',
    'CVV must be at most @number characters': 'CVV debe ser máximo de @number dígitos',
    'Expiry is required': 'Fecha de vencimiento requerida',
    'Expiry must be in format MM/YY': 'Fecha de vencimiento debe ser en formato MM/AA',
    'Shipping address is required': 'Dirección de envío requerida',

    'The charge on your bank statement may appear as OPENLIN*OPERAENLINEA': 'El cargo en tu Estado de Cuenta bancario podrá aparecer como OPENLIN*OPERAENLINEA',
};
